/** Typed, single-source access to build-time configuration. */
function readBool(value: string | undefined, fallback: boolean): boolean {
  if (value === undefined || value.trim() === '') return fallback
  return value.trim().toLowerCase() === 'true'
}

function readNumber(value: string | undefined, fallback: number): number {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : fallback
}

export const env = {
  /** Empty string = same-origin requests through the dev proxy at /api. */
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL ?? (import.meta.env.PROD ? 'https://eco-api-staging.up.railway.app' : 'https://eco-api-staging.up.railway.app')).trim(),
  /** Live API enabled by default */
  useMockApi: readBool(import.meta.env.VITE_USE_MOCK_API, false),
  mockLatencyMs: readNumber(import.meta.env.VITE_MOCK_LATENCY_MS, 450),
  defaultLanguage: (import.meta.env.VITE_DEFAULT_LANGUAGE ?? 'en').trim() === 'ar' ? 'ar' : 'en',
  isDevelopment: import.meta.env.DEV,
} as const

/** Names the data source in the UI footer so nobody mistakes mock data for real data. */
export const dataSourceLabel = env.useMockApi ? 'demo data' : 'live API'
